import { render, staticRenderFns } from "./StudentAssessmentAnswer.vue?vue&type=template&id=ef5d187a&scoped=true"
import script from "./StudentAssessmentAnswer.vue?vue&type=script&lang=js"
export * from "./StudentAssessmentAnswer.vue?vue&type=script&lang=js"
import style0 from "./StudentAssessmentAnswer.vue?vue&type=style&index=0&id=ef5d187a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5d187a",
  null
  
)

export default component.exports